import { render, staticRenderFns } from "./AbkSurveyNumberSvg.vue?vue&type=template&id=3c22fdc3&scoped=true&"
import script from "./AbkSurveyNumberSvg.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyNumberSvg.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyNumberSvg.vue?vue&type=style&index=0&id=3c22fdc3&lang=scss&scoped=true&"
import style1 from "./AbkSurveyNumberSvg.vue?vue&type=style&index=1&id=3c22fdc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22fdc3",
  null
  
)

export default component.exports